export interface CarVariantItem {
  name: string;
  colors?: string[];
  exShowroomPrice?: number;
  onRoadPrice?: number;
  downPayment?: string;
  emi?: string;
}

export interface CarItem {
  id: string;
  name: string;
  image?: string;
  carType?: 't-permit' | 'private';
  downPayment?: string;
  monthlyEmi?: string;
  exShowroomPrice?: number;
  variants: CarVariantItem[];
}

export const DEFAULT_CAR_INVENTORY: CarItem[] = [
  {
    id: 'maruti-suzuki-wagon-r',
    name: 'Maruti Suzuki Wagon-R',
    image: '/Website-Images/Cars/wagnor.jpg',
    carType: 't-permit',
    downPayment: '₹92,821',
    monthlyEmi: '₹11,884/month',
    exShowroomPrice: 650000,
    variants: [
      { name: 'H3 CNG', colors: ['White'] },
      { name: 'LXI CNG', colors: ['White', 'Silver', 'Grey', 'Red', 'Blue'] },
      { name: 'VXI CNG', colors: ['White', 'Silver', 'Grey', 'Red', 'Blue'] }
    ]
  },
  {
    id: 'maruti-suzuki-ertiga',
    name: 'Maruti Suzuki ERTIGA',
    image: '/Website-Images/Cars/ertiga.jpg',
    carType: 't-permit',
    downPayment: '₹99,347',
    monthlyEmi: '₹23,367/month',
    exShowroomPrice: 1000000,
    variants: [
      { name: 'Tour M CNG 1.5 MT', colors: ['White'] },
      { name: 'VXI CNG 1.5 MT', colors: ['White', 'Silver', 'Grey', 'Red', 'Blue'] },
      { name: 'ZXI CNG 1.5 MT', colors: ['White', 'Silver', 'Grey', 'Red', 'Blue'] }
    ]
  },
  {
    id: 'toyota-rumion',
    name: 'TOYOTA RUMION',
    image: '/Website-Images/Cars/Ruminum.jpg',
    carType: 't-permit',
    downPayment: '₹1,03,647',
    monthlyEmi: '₹23,344/month',
    exShowroomPrice: 850000,
    variants: [
      { name: 'S CNG 1.5 MT', colors: ['White', 'Silver', 'Grey'] }
    ]
  },
  {
    id: 'hyundai-aura',
    name: 'HYUNDAI AURA',
    image: '/Website-Images/Cars/Aura.jpg',
    carType: 't-permit',
    downPayment: '₹1,23,821',
    monthlyEmi: '₹15,809/month',
    exShowroomPrice: 700000,
    variants: [
      { name: 'E CNG', colors: ['White', 'Silver', 'Grey', 'Cherry Night'] },
      { name: 'S CNG', colors: ['White', 'Silver', 'Grey', 'Cherry Night'] },
      { name: 'SX CNG', colors: ['White', 'Silver', 'Grey', 'Cherry Night'] }
    ]
  },
  {
    id: 'maruti-suzuki-dzire',
    name: 'Maruti Suzuki Dzire',
    image: '/Website-Images/Cars/Dzire.jpg',
    carType: 't-permit',
    downPayment: '₹1,35,971',
    monthlyEmi: '₹17,531/month',
    exShowroomPrice: 750000,
    variants: [
      { name: "Tour's CNG", colors: ['White'] }
    ]
  },
  {
    id: 'toyota-innova-crysta',
    name: 'Toyota Innova Crysta',
    image: '/Website-Images/Cars/Crysta.jpg',
    carType: 't-permit',
    downPayment: '₹1,59,547',
    monthlyEmi: '₹38,557/month',
    exShowroomPrice: 1800000,
    variants: [
      { name: 'GX', colors: ['White', 'Silver', 'Pearl White'] },
      { name: 'GX+', colors: ['White', 'Silver', 'Pearl White'] },
      { name: 'VX', colors: ['White', 'Silver', 'Pearl White'] },
      { name: 'ZX', colors: ['White', 'Silver', 'Pearl White'] }
    ]
  },
  {
    id: 'maruti-suzuki-swift',
    name: 'Maruti Suzuki Swift',
    image: '/Website-Images/Cars/wagnor.jpg',
    carType: 'private',
    downPayment: '₹75,000',
    monthlyEmi: '₹11,500/month',
    exShowroomPrice: 649000,
    variants: [
      { name: 'LXI', colors: ['White', 'Silver', 'Red'] },
      { name: 'VXI', colors: ['White', 'Silver', 'Red', 'Blue'] },
      { name: 'ZXI', colors: ['White', 'Silver', 'Red', 'Blue'] }
    ]
  },
  {
    id: 'hyundai-creta',
    name: 'Hyundai Creta',
    image: '/Website-Images/Cars/Crysta.jpg',
    carType: 'private',
    downPayment: '₹1,45,000',
    monthlyEmi: '₹22,800/month',
    exShowroomPrice: 1100000,
    variants: [
      { name: 'EX', colors: ['White', 'Black', 'Titan Grey'] },
      { name: 'S(O)', colors: ['White', 'Black', 'Titan Grey'] },
      { name: 'SX(O)', colors: ['White', 'Black', 'Titan Grey'] }
    ]
  },
  {
    id: 'toyota-urban-cruiser-hyryder',
    name: 'Toyota Urban Cruiser Hyryder',
    image: '/Website-Images/Cars/hyryder.avif',
    carType: 'private',
    downPayment: '₹2,69,810',
    monthlyEmi: '₹27,415/month',
    exShowroomPrice: 1381000,
    variants: [
      { name: 'S CNG 1.5 MT', colors: ['White', 'Silver', 'Grey', 'Red'] },
      { name: 'G CNG 1.5 MT', colors: ['White', 'Silver', 'Grey', 'Red', 'Blue'] }
    ]
  },
  {
    id: 'toyota-innova-hycross',
    name: 'Toyota Innova Hycross',
    image: '/Website-Images/Cars/hycross.webp',
    carType: 'private',
    downPayment: '₹3,97,770',
    monthlyEmi: '₹38,950/month',
    exShowroomPrice: 1977000,
    variants: [
      { name: 'GX 7STR Petrol', colors: ['Super White', 'Silver Metallic', 'Attitude Black'] },
      { name: 'VX 7STR Hybrid', colors: ['Super White', 'Silver Metallic', 'Attitude Black'] }
    ]
  }
];

const STORAGE_KEY = 'asw_car_inventory_v3';
const INITIALIZED_KEY = 'asw_car_inventory_init_v3';

export const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');
  }
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.') || hostname.startsWith('10.')) {
      return `${protocol}//${hostname}:5000`;
    }
  }
  return 'https://backend.aswcars.com';
};

export const formatCarImage = (img?: string): string => {
  if (!img) return '/Website-Images/Cars/wagnor.jpg';
  if (img.startsWith('/uploads/')) {
    const base = getApiUrl();
    return `${base}${img}`;
  }
  return img;
};

// Synchronous getter for instant UI load from localStorage
export const getCarInventory = (): CarItem[] => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    const isInitialized = localStorage.getItem(INITIALIZED_KEY);

    if (saved !== null) {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed)) {
        // If user explicitly deleted all cars, respect the empty array!
        return parsed.map(c => ({ ...c, image: formatCarImage(c.image) }));
      }
    }

    // First time setup only
    if (!isInitialized) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(DEFAULT_CAR_INVENTORY));
      localStorage.setItem(INITIALIZED_KEY, 'true');
      return DEFAULT_CAR_INVENTORY;
    }

    return [];
  } catch (e) {
    console.error('Error reading car inventory from storage:', e);
    return DEFAULT_CAR_INVENTORY;
  }
};

// Async fetch from backend server
export const fetchCarInventoryFromServer = async (): Promise<CarItem[]> => {
  try {
    const base = getApiUrl();
    const res = await fetch(`${base}/api/crm/cars`, {
      headers: { 'Accept': 'application/json' }
    });
    if (res.ok) {
      const data = await res.json();
      const carsList: CarItem[] = data.cars || data.data || [];
      if (Array.isArray(carsList)) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(carsList));
        localStorage.setItem(INITIALIZED_KEY, 'true');
        window.dispatchEvent(new Event('asw_cars_updated'));
        return carsList.map(c => ({ ...c, image: formatCarImage(c.image) }));
      }
    }
  } catch (err) {
    console.warn('⚠️ Could not fetch cars from server, using local storage cache:', err);
  }
  return getCarInventory();
};

// Save inventory to both localStorage and backend server
export const saveCarInventory = (cars: CarItem[]): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cars));
    localStorage.setItem(INITIALIZED_KEY, 'true');
    window.dispatchEvent(new Event('asw_cars_updated'));

    // Asynchronously sync to backend server
    const base = getApiUrl();
    fetch(`${base}/api/crm/cars/sync`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ cars })
    }).then(res => res.json())
      .then(resData => {
        if (resData.success) {
          console.log(`✅ [Cars Inventory] Successfully synced ${cars.length} cars to server.`);
        }
      })
      .catch(err => {
        console.warn('⚠️ Failed to sync car inventory to server in background:', err.message);
      });
  } catch (e) {
    console.error('Error saving car inventory:', e);
  }
};

// Permanently delete a car from backend server and local cache
export const deleteCarPermanently = async (carId: string, carName: string): Promise<CarItem[]> => {
  const currentCars = getCarInventory();
  const updated = currentCars.filter(c => 
    c.id.toLowerCase().trim() !== carId.toLowerCase().trim() && 
    c.name.toLowerCase().trim() !== carName.toLowerCase().trim()
  );

  // Update local immediately
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  localStorage.setItem(INITIALIZED_KEY, 'true');
  window.dispatchEvent(new Event('asw_cars_updated'));

  // Delete on server
  try {
    const base = getApiUrl();
    const target = encodeURIComponent(carId || carName);
    const res = await fetch(`${base}/api/crm/cars/${target}`, {
      method: 'DELETE'
    });
    if (!res.ok) {
      // Fallback: sync the whole updated array
      await fetch(`${base}/api/crm/cars/sync`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cars: updated })
      });
    }
    console.log(`🗑️ [Cars Inventory] Car "${carName}" deleted permanently from server.`);
  } catch (err) {
    console.warn('⚠️ Error calling server delete, syncing updated array:', err);
    try {
      const base = getApiUrl();
      await fetch(`${base}/api/crm/cars/sync`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cars: updated })
      });
    } catch (e) {
      console.error('Failed to sync updated array after delete:', e);
    }
  }

  return updated;
};

// Permanently delete a variant from backend server and local cache
export const deleteVariantPermanently = async (carName: string, variantName: string): Promise<CarItem[]> => {
  const currentCars = getCarInventory();
  const updated = currentCars.map(car => {
    if (car.name.toLowerCase().trim() === carName.toLowerCase().trim()) {
      return {
        ...car,
        variants: car.variants.filter(v => v.name.toLowerCase().trim() !== variantName.toLowerCase().trim())
      };
    }
    return car;
  });

  // Update local immediately
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  localStorage.setItem(INITIALIZED_KEY, 'true');
  window.dispatchEvent(new Event('asw_cars_updated'));

  // Delete on server
  try {
    const base = getApiUrl();
    const cTarget = encodeURIComponent(carName);
    const vTarget = encodeURIComponent(variantName);
    const res = await fetch(`${base}/api/crm/cars/${cTarget}/variants/${vTarget}`, {
      method: 'DELETE'
    });
    if (!res.ok) {
      await fetch(`${base}/api/crm/cars/sync`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cars: updated })
      });
    }
    console.log(`🗑️ [Cars Inventory] Variant "${variantName}" deleted permanently from server.`);
  } catch (err) {
    console.warn('⚠️ Error calling server delete variant, syncing array:', err);
    try {
      const base = getApiUrl();
      await fetch(`${base}/api/crm/cars/sync`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cars: updated })
      });
    } catch (e) {
      console.error('Failed to sync updated array after variant delete:', e);
    }
  }

  return updated;
};

export const upsertCarToInventory = (
  carName: string, 
  variantName: string, 
  carType: 't-permit' | 'private' = 't-permit',
  imageUrl?: string
): void => {
  try {
    const cars = getCarInventory();
    const existingIndex = cars.findIndex(c => c.name.toLowerCase().trim() === carName.toLowerCase().trim());
    
    if (existingIndex >= 0) {
      const car = cars[existingIndex];
      car.carType = carType;
      if (imageUrl) {
        car.image = imageUrl;
      }
      const hasVariant = car.variants.some(v => v.name.toLowerCase().trim() === variantName.toLowerCase().trim());
      if (!hasVariant && variantName) {
        car.variants.push({ name: variantName, colors: ['White', 'Silver', 'Grey'] });
      }
      cars[existingIndex] = car;
    } else {
      const slug = carName.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      const newCar: CarItem = {
        id: slug + '-' + Date.now(),
        name: carName.trim(),
        image: imageUrl || '/Website-Images/Cars/wagnor.jpg',
        carType: carType,
        variants: variantName ? [{ name: variantName.trim(), colors: ['White', 'Silver', 'Grey'] }] : []
      };
      cars.push(newCar);
    }
    
    saveCarInventory(cars);
  } catch (e) {
    console.error('Error upserting car to inventory:', e);
  }
};


